import { PROGRESS_INCREMENTER, ONE_BY_ONE_INCREMENTER, } from "../incrementer";
import { PING_PONG_TIMELINE, PROGRESS_TIMELINE } from "../timeline";
import { OneByOneIncrementer } from "../incrementer/oneByOneIncrementer";
import { ProgressIncrementer } from "../incrementer/progressIncrementer";
import { PingPongTimeline } from "../timeline/PingPongTimeline";
import { ProgressTimeline } from "../timeline/ProgressTimeline";
var VERBOSE = false;
var Animation = /** @class */ (function () {
    function Animation(target, property) {
        this._dirty = true;
        this._incrementerType = PROGRESS_INCREMENTER;
        this._timelineType = PROGRESS_TIMELINE;
        this._time = 0;
        VERBOSE && console.log('create animation', target, property);
        this._target = target;
        this._property = property;
        this._createIncrementer();
        this._createTimeline();
        this._dirty = false;
    }
    Object.defineProperty(Animation.prototype, "target", {
        get: function () {
            return this._target;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "property", {
        get: function () {
            return this._property;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "incrementerType", {
        get: function () {
            return this._incrementerType;
        },
        set: function (incrementerType) {
            if (incrementerType === this._incrementerType) {
                return;
            }
            this._incrementerType = incrementerType;
            this._createIncrementer();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "incrementer", {
        get: function () {
            return this._incrementer;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * The length of the property we animate. This can change during its lifecycle.
     */
    Animation.prototype._propertyLength = function () {
        return (typeof this._target._expectTransformsLength === 'function') ? this._target._expectTransformsLength(1) : 1;
    };
    Animation.prototype._createIncrementer = function () {
        // TODO: we don't have a nice deformer vs text deformer type definition yet
        var count = this._propertyLength();
        switch (this.incrementerType) {
            case ONE_BY_ONE_INCREMENTER:
                this._incrementer = new OneByOneIncrementer(count);
                break;
            case PROGRESS_INCREMENTER:
                this._incrementer = new ProgressIncrementer(count);
                break;
            default:
                throw new Error("Incrementer ".concat(this.incrementerType, " not found"));
        }
    };
    Object.defineProperty(Animation.prototype, "timelineType", {
        get: function () {
            return this._timelineType;
        },
        set: function (timelineType) {
            if (timelineType === this._timelineType) {
                return;
            }
            this._timelineType = timelineType;
            this._createTimeline();
        },
        enumerable: false,
        configurable: true
    });
    Animation.prototype._createTimeline = function () {
        switch (this.timelineType) {
            case PING_PONG_TIMELINE:
                this._timeline = new PingPongTimeline();
                break;
            case PROGRESS_TIMELINE:
                this._timeline = new ProgressTimeline();
                break;
            default:
                throw new Error("Timeline ".concat(this.timelineType, " not found"));
        }
    };
    Object.defineProperty(Animation.prototype, "timeline", {
        get: function () {
            return this._timeline;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "interpolation", {
        get: function () {
            return this._interpolation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Animation.prototype, "dirty", {
        get: function () {
            if (this.incrementer && this.incrementer.length !== this._propertyLength()) {
                VERBOSE && console.log('property length changed', this.incrementer.length, this._propertyLength());
                return true;
            }
            return this._dirty;
        },
        enumerable: false,
        configurable: true
    });
    Animation.prototype.update = function () {
        VERBOSE && console.log('update', this.dirty);
        if (!this.dirty) {
            return;
        }
        VERBOSE && console.log('setting length to', this._propertyLength());
        this.incrementer.length = this._propertyLength();
        this._updateTimeValue();
        this._dirty = false;
    };
    Object.defineProperty(Animation.prototype, "time", {
        get: function () {
            return this._time;
        },
        set: function (value) {
            VERBOSE && console.log('setting time from', this._time, 'to', value);
            if (value === this.time) {
                return;
            }
            this._time = value;
            this._updateTimeValue();
        },
        enumerable: false,
        configurable: true
    });
    Animation.prototype._updateTimeValue = function () {
        if (this._timeline === undefined) {
            throw new Error('Timeline not build yet');
        }
        if (this._incrementer === undefined) {
            throw new Error('Incrementer not build yet');
        }
        VERBOSE && console.log('timeline', this._timeline.start, this._timeline.end);
        var progress = this._timeline.value(this.time);
        VERBOSE && console.log('progress', progress);
        this._incrementer.progress = progress;
        this._incrementer.update();
        VERBOSE && console.log('setting', this._property, 'to', this._incrementer.array);
        this._target[this._property] = this._incrementer.array;
    };
    return Animation;
}());
export { Animation };
